/** A real IANA zone name: the runtime's own clock data knows it. */
export function isTimeZone(name: string): boolean {
  try {
    return Boolean(Intl.DateTimeFormat("en-US", { timeZone: name }).resolvedOptions().timeZone);
  } catch {
    return false;
  }
}
